import * as React from 'react';
import { Link } from 'react-router-dom';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';

interface BrandListViewProps extends ComponentViewProps<DataSet<BrandSummary>> {
	onItemDoubleClicked?: (item: BrandSummary) => any;
}

export class BrandListView extends React.Component<BrandListViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);
		const columns: Column[] = [
			{
				key: 'name',
				title: 'Name',
				dataIndex: 'name',
				render: (text, record: BrandSummary) => <Link to={`/general/brands/${record.id}`}>{text}</Link>,
			},
			{
				key: 'prefix',
				title: 'Prefix',
				dataIndex: 'prefix',
			},
			{
				key: 'description',
				title: 'Description',
				dataIndex: 'description'
			}
		];
		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/brands/list/brand-list.view.tsx